import {Injectable} from '@angular/core';
import {ConfigService} from '../../../../core/services/config/config.service';

@Injectable()
export class MeanPressureComputationService {

  private _pressureBuffer: Array<number> = [];

  constructor(private readonly _configService: ConfigService) {
  }

  private get bufferMaxLength(): number {
    return this._configService.config.measurements.meanPressureComputation.computationWindowSize;
  }

  public clearPressureData(): void {
    this._pressureBuffer = [];
  }

  public computeCurrentMeanPressure(pressure: number): number | null {
    // add pressure to buffer
    this.addPressureValue(pressure);

    // first value will not be counted with reduce() function, so initialize counter accordingly
    let validValuesCount: number = isNaN(this._pressureBuffer.at(0)!) ? 0 : 1;
    // compute accumulation of valid values and count them
    const accumulatedValidValues =
      this._pressureBuffer.reduce((accumulated: number, current: number): number => {
        if (isNaN(current)) {
          return accumulated;
        }
        validValuesCount++;
        if (isNaN(accumulated)) {
          return current;
        }
        return accumulated + current;
      });

    return (validValuesCount > 0) ? (accumulatedValidValues / validValuesCount) : null;
  }

  private addPressureValue(pressure: number): void {
    this._pressureBuffer.push(pressure);
    if (this._pressureBuffer.length > this.bufferMaxLength) {
      this._pressureBuffer.shift();
    }
  }
}
